import { baseSeriesMark } from "../base/constant";

export const LiquidSeriesMark = Object.assign(Object.assign({}, baseSeriesMark), {
    liquidGroup: {
        name: "liquidGroup",
        type: "group"
    },
    liquid: {
        name: "liquid",
        type: "liquid"
    },
    liquidBackground: {
        name: "liquidBackground",
        type: "group"
    },
    liquidOutline: {
        name: "liquidOutline",
        type: "group"
    }
});
//# sourceMappingURL=constant.js.map
